import { addDataLayerOfRecipeToList } from "@/helpers/dataLayer";

export const addRecipeToListDataLeyarFun = (addTolist: any) => {
  addTolist.forEach((item: any) => {
    addDataLayerOfRecipeToList({
      event: item.event,
      recipe_name: item.recipe_name,
      list_name: item.list_name,
      recipe_list_name: item.recipe_list_name,
      page_title: document.title, // You can replace this if you need another dynamic page title
    });
  });
};

export const removeToListDataLeyarFun = (removeToList: any) => {
  removeToList.forEach((item: any) => {
    addDataLayerOfRecipeToList({
      event: item.event,
      recipe_name: item.recipe_name,
      list_name: item.list_name,
      recipe_list_name: item.recipe_list_name,
      page_title: document.title,
    });
  });
};
